<template>
  <v-container fluid>
    <el-overlay-loading :loading="pageloading" />
    <h3 class="mb-4">Savitarnos užsakymai</h3>
    <paieska-tvirtinimas-search
      class="mt-1 mb-1"
      :loading="loadingList"
      @search="searchTvirtinimas"
    />

    <v-data-table
      :headers="filteredHeaders"
      :items="itemsList"
      :item-class="rowClass"
      :search="search"
      :footer-props="{
        showFirstLastPage: true,
        showCurrentPage: true,
        itemsPerPageText: 'Rodyti po:',
        itemsPerPageAllText: 'visi',
        itemsPerPageOptions: itemsPerPageOptions,
      }"
      :hide-default-footer="hideFooter"
      :sort-by.sync="pagination.sort"
      :sort-desc.sync="pagination.sortDesc"
      :server-items-length="pagination.total"
      :items-per-page="pagination.pageSize"
      :page.sync="pagination.page"
      @update:options="updatePagination"
      item-key="pai_id"
      :expanded.sync="expanded"
      single-expand
    >
      <template #[`item.pai_busena_pavadinimas`]="{ item }">
        <el-busena
          :busena="item.pai_busena_pavadinimas"
          :color="item.busenaColor"
        />
      </template>
      <template #[`item.pai_duomenu_naudojimo_tikslas`]="{ item }">
        <div class="text-cut-4">
          {{ item.pai_duomenu_naudojimo_tikslas }}
        </div>
      </template>
      <template #[`item.pai_teisinis_pagrindas`]="{ item }">
        <div class="text-cut-4">
          {{ item.pai_teisinis_pagrindas }}
        </div>
      </template>
      <template #[`item.pagrindas_bylos`]="{ item }">
        <el-byla
          v-for="byla in item.pagrindas_bylos"
          :key="byla.byl_id"
          :byla="byla"
          color="primary"
          with-name
        />
      </template>
      <template #[`item.actions`]="{ item }">
        <div class="table-actions nowrap">
          <v-icon
            dense
            :color="`${item.expandedResult ? 'primary' : ''}`"
            class="table-action mx-2"
            @click="viewExpandedResult(item)"
          >
            mdi-eye-check
          </v-icon>

          <el-byla
            v-for="byla in item.zurnalas_bylos"
            :key="byla.byl_id"
            :byla="byla"
            color="primary"
          />
        </div>
        <div>
          <el-button
            v-if="item.canTikrinti"
            class="my-1"
            x-small
            @click.native="paieskaAction(item, 'tikrinti')"
            >Tikrinti</el-button
          >
          <el-button
            v-if="item.canPatvirtinti"
            class="my-1"
            x-small
            @click.native="paieskaAction(item, 'patvirtinti')"
            >Patvirtinti</el-button
          >
          <el-button
            v-if="item.canAtmesti"
            class="my-1"
            x-small
            @click.native="paieskaAtmetimas(item)"
            >Atmesti</el-button
          >
        </div>
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length" class="pt-4">
          <el-textarea
            readonly
            label="Paslaugos pavadinimas"
            v-model="item.pai_tipas_pavadinimas"
          />
          <el-textarea
            v-if="!item.hidePagrindas"
            readonly
            label="Duomenų naudojimo tikslas"
            v-model="item.pai_duomenu_naudojimo_tikslas"
          />
          <el-textarea
            v-if="!item.hidePagrindas"
            readonly
            label="Teisinis pagrindas"
            v-model="item.pai_teisinis_pagrindas"
          />
          <el-textarea
            v-if="item.pai_atmetimo_priezastis"
            readonly
            label="Atmetimo priežastis"
            v-model="item.pai_atmetimo_priezastis"
          />
          <el-textarea
            v-if="item.showIgaliojimas"
            readonly
            label="Igaliojimo informacija"
            v-model="item.igaliojimas"
          />
        </td>
      </template>
      <template slot="loading">
        Kraunasi...
      </template>
      <template slot="no-results">
        Duomenų nėra
      </template>
      <template slot="no-data">
        Duomenų nėra
      </template>
      <template #[`footer.page-text`]="props">
        Rodoma {{ props.pageStart }}-{{ props.pageStop }} iš
        {{ props.itemsLength }}
      </template>
    </v-data-table>

    <modal-paieska-atmetimas
      :key="modalPaieskaAtmetimasKey"
      :pai-id="modalPaieskaAtmetimasPaiId"
      :is-sign="isSign"
      v-model="showPaieskaAtmetimas"
      @savedData="savedPaieskaAtmetimas"
    />

    <modal-pazyma-atmetimas
      :key="modalPazymaAtmetimasKey"
      :pai-id="modalPazymaAtmetimasPaiId"
      :item="modalPazymaAtmetimasItem"
      v-model="showPazymaAtmetimas"
      @savedData="savedPazymaAtmetimas"
    />
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import PaieskaTvirtinimasSearch from './PaieskaTvirtinimasSearch'
import ModalPaieskaAtmetimas from '../modals/ModalPaieskaAtmetimas'
import ModalPazymaAtmetimas from '../modals/ModalPazymaAtmetimas'
import rowClass from '../../mixins/rowClass'
import math from '../../mixins/math'

export default {
  name: 'PaieskaTvirtinimas',
  components: {
    PaieskaTvirtinimasSearch,
    ModalPazymaAtmetimas,
    ModalPaieskaAtmetimas,
  },
  mixins: [rowClass, math],
  data: () => ({
    pageloading: true,
    loading: false,
    paieskos: [],
    search: null,
    showList: false,
    loadingList: true,
    saugojimoLaikas: null,
    israsoLaikas: null,
    searchData: {},
    pagination: {
      page: 1,
      pageSize: 10,
      total: 0,
      totalPages: 0,
      sort: null,
      sortDesc: [],
      direction: 'asc',
    },
    itemsPerPageOptions: [10, 50, 100],
    paginationloading: false,
    expanded: [],
    expandedRow: null,
    showPaieskaAtmetimas: false,
    modalPaieskaAtmetimasRefresh: 0,
    modalPaieskaAtmetimasPaiId: null,
    showPazymaAtmetimas: false,
    modalPazymaAtmetimasRefresh: 0,
    modalPazymaAtmetimasPaiId: null,
    modalPazymaAtmetimasItem: null,
  }),
  computed: {
    ...mapGetters(['paieskaPavadinimas', 'signBusena']),
    headers() {
      return [
        {
          text: 'Numeris',
          align: 'start',
          value: 'pai_numeris',
        },
        {
          text: 'PAS numeris',
          align: 'start',
          value: 'uzs_paslaugos_pra_id',
          hide: this.isLocal,
        },
        {
          text: 'Apimtis',
          align: 'start',
          value: 'pai_apimtis_pavadinimas',
        },
        {
          text: 'Užsakęs asmuo',
          align: 'start',
          value: 'pai_sukure',
          sortable: false,
          hide: this.isLocal,
        },
        {
          text: 'Užsakymo parametrai',
          align: 'start',
          value: 'pai_atlikta_pagal',
          sortable: false,
        },
        {
          text: 'Būsena',
          align: 'start',
          value: 'pai_busena_pavadinimas',
        },
        {
          text: 'Būsenos data',
          align: 'start',
          value: 'pai_atnaujinimo_data',
          hide: this.isLocal,
        },
        {
          text: 'Duomenų naudojimo tikslas',
          align: 'start',
          value: 'pai_duomenu_naudojimo_tikslas',
          hide: true,
        },
        {
          text: 'Teisinis pagrindas',
          align: 'start',
          value: 'pai_teisinis_pagrindas',
          hide: true,
        },
        {
          text: 'Pagrindžiantys dokumentai',
          align: 'start',
          value: 'pagrindas_bylos',
          sortable: false,
          hide: this.isLocal,
        },
        {
          text: 'Užsakymo data',
          align: 'center',
          value: 'pai_sukurimo_data',
        },
        {
          text: 'Sutvarkyti iki',
          align: 'center',
          value: 'sutvarkyti_iki',
        },
        {
          text: 'Vykdytojas',
          align: 'start',
          value: 'busena_pakeite',
          sortable: false,
        },
        {
          text: 'Veiksmai',
          align: 'start',
          value: 'actions',
          sortable: false,
        },
      ]
    },
    filteredHeaders() {
      return this.headers.filter(item => {
        return !item.hide
      })
    },
    itemsList() {
      return this.paieskos.map(item => {
        item.expandedResult = false
        item.canView = true

        item.pai_tipas_pavadinimas =
          this.paieskaPavadinimas[item.pai_tipas_kodas] ?? ''
        item.busenaColor = item.pai_busena === 'ivykdyta' ? 'green' : 'default'

        if (item.pai_busena === 'laukia_patvirtinimo') {
          item.canTikrinti = true
        }
        if (item.pai_busena === 'tikrinama') {
          item.canPatvirtinti = true
          item.canAtmesti = true
        }

        let byla_url = ''
        if (item.pai_tipas == 'pazyma' || item.pai_tipas == 'sklypas') {
          if (item.pai_parametrai.paz_tipas === 'zemes-ukio') {
            item.pai_tipas_pavadinimas = this.$t(
              'Pažyma apie žemės ūkio paskirties žemę'
            )
          }
          if (item.pai_parametrai.paz_tipas === 'misku-ukio') {
            item.pai_tipas_pavadinimas = this.$t(
              'Pažyma apie miškų ūkio paskirties žemę'
            )
          }

          item.hidePagrindas = true
          item.showIgaliojimas = !!item.igaliojimas
          byla_url = 'ntrpaslaugos/'
        }

        item.pagrindas_bylos = item.pagrindas_bylos.map(byla => {
          byla.byl_tipas = 'pagrindas'
          byla.icon_title = byla.byl_pavadinimas
          return {
            ...byla,
            byl_url: `${byla_url}byla/${byla.byl_id}/${byla.byl_hash}/content`,
            obj_tipas: item.obj_tipas,
          }
        })

        item.zurnalas_bylos = item.zurnalas_bylos.map(byla => {
          // byla.byl_tipas = 'pagrindas'
          // byla.icon_title = byla.byl_pavadinimas
          byla.obj_dokumento_numeris = byla.byl_dokumento_nr
          byla.pranesimas_numeris = item.pai_id
          return {
            ...byla,
            byl_url: `${byla_url}byla/${byla.byl_id}/${byla.byl_hash}/content`,
            obj_tipas: item.obj_tipas,
          }
        })

        return item
      })
    },
    hideFooter() {
      return this.pagination.total <= 10
    },
    modalPaieskaAtmetimasKey() {
      return `paieskaatmetimas-${this.modalPaieskaAtmetimasRefresh}`
    },
    modalPazymaAtmetimasKey() {
      return 'pazymaatmetimas' + this.modalPazymaAtmetimasRefresh
    },
    isLocal() {
      return process.env.VUE_APP_LOCAL === 'local'
    },
    isSign() {
      return this.$route.params.sign && !!this.signBusena
    },
    signPaieskaID() {
      return this.$route.params.paieskaID
    },
  },
  created() {
    if (this.isSign) {
      this.openSign(this.signPaieskaID)
    }
  },
  watch: {
    loading() {
      this.expanded = []
      this.expandedRow = null
    },
  },
  methods: {
    searchTvirtinimas(searchData, silent = false) {
      this.searchData = searchData
      this.loadingList = !silent

      if (!silent) {
        this.pagination.page = 1
      }

      const data = {
        ...this.pagination,
        search: { ...searchData },
      }
      this.$axios
        .post(`paieska/tvirtinama`, data)
        .then(res => {
          this.paieskos = res.data.paieskos
          this.pagination = { ...this.pagination, ...res.data.pagination }
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.pageloading = false
          this.loadingList = false
          this.paginationloading = false
          this.showList = true
        })
    },
    updatePagination(pagination) {
      if (this.paginationloading) {
        return
      }
      this.paginationloading = true
      this.pagination.page = pagination.page
      this.pagination.pageSize = pagination.itemsPerPage
      this.pagination.sort = pagination.sortBy[0]
      this.pagination.sortDesc = pagination.sortDesc
      this.pagination.direction = pagination.sortDesc[0] ? 'desc' : 'asc'

      if (!this.loadingList) {
        this.updateList()
      }
    },
    updateList() {
      this.searchTvirtinimas(this.searchData, true)
    },
    updateItem(item, tvirtinimas) {
      item.pai_busena = tvirtinimas.pai_busena
      item.pai_busena_pavadinimas = tvirtinimas.pai_busena_pavadinimas
      item.busena_pakeite = tvirtinimas.busena_pakeite

      if (item.pai_busena === 'tikrinama') {
        item.canTikrinti = false
        return
      }

      const byla_url = ''
      item.zurnalas_bylos = tvirtinimas.zurnalas_bylos.map(byla => {
        byla.obj_dokumento_numeris = byla.byl_dokumento_nr
        byla.pranesimas_numeris = item.pai_id
        return {
          ...byla,
          byl_url: `${byla_url}byla/${byla.byl_id}/${byla.byl_hash}/content`,
          obj_tipas: item.obj_tipas,
        }
      })

      item.canTikrinti = false
      item.canPatvirtinti = false
      item.canAtmesti = false
    },
    paieskaAction(item, action) {
      this.$axios
        .post(`paieska/${item.pai_id}/${action}`)
        .then(res => {
          window._VMA.$emit('DATA_OK', res.data.message)
          this.updateItem(item, res.data.tvirtinimas)
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
    },
    paieskaAtmetimas(item) {
      if (item.yra_pazyma) {
        this.modalPazymaAtmetimasPaiId = item.pai_id
        this.modalPazymaAtmetimasItem = item
        this.modalPazymaAtmetimasRefresh++
        this.showPazymaAtmetimas = true
        return
      }

      this.modalPaieskaAtmetimasPaiId = item.pai_id
      this.modalPaieskaAtmetimasRefresh++
      this.showPaieskaAtmetimas = true
    },
    savedPazymaAtmetimas(payload) {
      const data = {
        pai_atmetimo_priezastis: payload.priezastis,
      }
      this.$axios
        .post(`paieska/${payload.pai_id}/atmesti/pazyma`, data)
        .then(res => {
          window._VMA.$emit('DATA_OK', res.data.message)
          this.updateItem(payload.item, res.data.tvirtinimas)
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
    },
    savedPaieskaAtmetimas(paieskaId) {
      this.$axios
        .get(`paieska/${paieskaId}/atmesti/paieska`)
        .then(res => {
          window._VMA.$emit('DATA_OK', res.data.message)

          const item = this.itemsList.find(item => item.pai_id == paieskaId)
          if (item) {
            this.updateItem(item, res.data.tvirtinimas)
          }
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.showPaieskaAtmetimas = false
          this.$store.dispatch('signBusena', null)
        })
    },
    viewExpandedResult(item) {
      item.expandedResult = !item.expandedResult
      this.clearExpanded(item)
      this.expanded = []
      this.expandedRow = null
      if (item.expandedResult) {
        this.expanded = [item]
        this.expandedRow = item.pai_id
      }
    },
    clearExpanded(item) {
      this.paieskos.forEach(e => {
        if (e.pai_id != item.pai_id) {
          e.expandedResult = false
        }
      })
    },
    getActiveClass(item) {
      return item.pai_id === this.expandedRow ? 'row-active' : ''
    },
    openSign(signPaieskaID) {
      this.modalPaieskaAtmetimasPaiId = parseInt(signPaieskaID)
      this.modalPaieskaAtmetimasRefresh++
      this.showPaieskaAtmetimas = true
    },
  },
}
</script>
<style lang="scss" scoped>
.dataContainer {
  max-width: 800px;
}
.disclaimer {
  color: rgba(0, 0, 0, 0.6);
  font-size: 0.875rem;
  font-weight: 400;
}
.table-actions {
  display: inline-flex;
  align-items: flex-start;
  white-space: normal;
}
</style>
